import { Boxes, Building2, CalendarCheck, ClipboardList, Coins, ShieldCheck } from "lucide-react";
import type { BlogPost } from "@/content/blogPosts";

const icons = {
  coins: Coins,
  clipboard: ClipboardList,
  boxes: Boxes,
  building: Building2,
  shield: ShieldCheck,
  calendar: CalendarCheck,
} as const;

/** Branded illustration tile used on blog cards and the featured article. */
const BlogPostIcon = ({
  icon,
  size = "md",
}: {
  icon: BlogPost["icon"];
  size?: "md" | "lg";
}) => {
  const Icon = icons[icon];
  const box = size === "lg" ? "w-20 h-20 rounded-3xl" : "w-14 h-14 rounded-2xl";
  const glyph = size === "lg" ? "w-9 h-9" : "w-6 h-6";
  return (
    <div
      className={`${box} bg-[#FDC00E] flex items-center justify-center shadow-[inset_0_1px_0_rgba(255,255,255,0.6)]`}
      aria-hidden="true"
    >
      <Icon className={`${glyph} text-[#1a1a1a]`} strokeWidth={1.8} />
    </div>
  );
};

export default BlogPostIcon;